export type ContactHealthScoreStatus = 'healthy' | 'attention' | 'atRisk';
export type ContactHealthTrend = 'improving' | 'stable' | 'declining';

export const getContactHealthScoreStatus = (score: number): ContactHealthScoreStatus => {
    if (score >= 70) return 'healthy';
    if (score >= 45) return 'attention';
    return 'atRisk';
};

export const getContactHealthScoreTrend = (score: number): ContactHealthTrend => {
    if (score >= 70) return 'improving';
    if (score >= 30) return 'stable';
    return 'declining';
};
